var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33332L4.66667 5.33332M8 10.6667L4.66667 10.6667M14 2.66666L10.6667 5.99999L9.33333 4.66666M14 7.99999L10.6667 11.3333L9.33333 9.99999M3.33333 5.33332C3.33333 5.70151 3.03486 5.99999 2.66667 5.99999C2.29848 5.99999 2 5.70151 2 5.33332C2 4.96513 2.29848 4.66666 2.66667 4.66666C3.03486 4.66666 3.33333 4.96513 3.33333 5.33332ZM3.33333 10.6667C3.33333 11.0348 3.03486 11.3333 2.66667 11.3333C2.29848 11.3333 2 11.0348 2 10.6667C2 10.2985 2.29848 9.99999 2.66667 9.99999C3.03486 9.99999 3.33333 10.2985 3.33333 10.6667Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListQuestion);
export default __webpack_public_path__ + "static/media/list-question.dbb2482dda1dede1f710eaa284ca9b52.svg";
export { ForwardRef as ReactComponent };